import Back from "../../components/common/BackComp"
import "./index.less"
import ButtonComp from "../../components/common/ButtonComp"
import Turntable from "../../components/turntable"
import day from "@/assets/images/day.png"
import x from '@/assets/images/start/x.png'
import close from "@/assets/images/task/close.png"
import { CountDown, Dialog, Toast } from "react-vant"
import envelope_top from "@/assets/images/myInvites/envelope_top.png"
import copy_Completed from '@/assets/images/tabbar/copy_Completed.png'
import copy from '@/assets/images/tabbar/copy.png'
import finger from "@/assets/images/myInvites/finger.png"
import right from "@/assets/images/myInvites/right.png"
import left from "@/assets/images/myInvites/left.png"
import winners_list from "@/assets/images/myInvites/winners_list.png"
// import WebApp from '@twa-dev/sdk'
import { useCallback, useEffect, useMemo, useState } from "react"
import { rewards_count, getRewards, getPddInfo, getUserPddInfo, getPddMarquee, getActivity_list, getPddLottery } from '@/api/url.js'


import card4 from "@/assets/images/myInvites/card4.png"
import card3 from "@/assets/images/myInvites/card3.png"
import usdt from "@/assets/images/myInvites/usdt.png"
import coin from '@/assets/images/coin.png'
import diamond_card from "@/assets/images/myInvites/diamond_card.png"
import gold_cards from "@/assets/images/myInvites/gold_cards.png"

import star from '@/assets/images/ranks/star.png'
import rules_bg from "@/assets/images/myInvites/rules_bg.png"
import rules_bg1 from "@/assets/images/myInvites/rules_bg1.png"
import rules_bg2 from "@/assets/images/myInvites/rules_bg2.png"
import rules_bg3 from "@/assets/images/myInvites/rules_bg3.png"
import rules_bg4 from "@/assets/images/myInvites/rules_bg4.png"
import rules_bg5 from "@/assets/images/myInvites/rules_bg5.png"
import start_bg from "@/assets/images/myInvites/start_bg.png"
import start_bg1 from "@/assets/images/myInvites/start_bg1.png"
import { formatIdString, formatNumber, FormattingNumber, HighlightPercentages } from "../../utils"
import InvitingPopup from "../inviting/invitingPopup"
import WithdrawDialog from "./withdrawDialog"
import LuckyDrawprizeDialog from "./LuckyDrawprizeDialog"
import { useNavigate } from "react-router-dom"
import RedPacket from "../../components/redPacket/RedPacket"
import { useDispatch, useSelector } from "react-redux"
import CloseComp from "../../components/common/CloseComp"
import Marquee from "react-fast-marquee"
import { TwitterShareButton } from "react-share"
import { changeLoginState } from "../../store/module/h5Login"
import { useTranslation } from "react-i18next"


const myInvites = () => {
  const dataStatistics = useSelector((state: any) => state.progress.dataStatistics)
  const { t, i18n } = useTranslation();
  const id: any = localStorage.getItem('userId')
  const isShowRedPacket = useSelector((state: any) => state.lottery.isShowRedPacket)
  const [invitation_code] = useState<any>(localStorage.getItem('inviteCode'))
  const [invitation_msy] = useState(localStorage.getItem('invitation_msy'))
  const [loading, setLoading] = useState(false)
  const [isCopy, setIsCopy] = useState(false)
  const [dialog, setDialog] = useState(false)
  const [isWithdraw, setIsWithdraw] = useState(false)
  const [startDialog, setStartDialog] = useState(false)
  const [rewardsList, setRewardsList] = useState([])
  const [visibleMy, setVisibleMy] = useState(false)
  const [luckyDrawprize, setLuckyDrawprize] = useState(false)
  const [IsAll, setIsAll] = useState(0)
  const [lottery, setLottery] = useState<any>([0])
  const [userInfo, setUserInfo] = useState<any>([0])
  const [activityList, setActivityList] = useState<any>({})
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [rewardsData, setRewardsData] = useState<any>({
    count: 0,
    invitation_code: "",
    premium_reward: '',
    standard_reward: '',
    premium: [
      { count: 0, people: 0 },
      { count: 0, people: 0 }
    ],
    standard: [
      { count: 0, people: 0 },
      { count: 0, people: 0 }
    ]
  })


  const dataList = useMemo(() => {
    return IsAll == 1 ? activityList.my || [] : activityList.all || []
  }, [IsAll, activityList])

  const setPddInfo = useCallback(async () => {
    try {
      const { code, data } = await getPddInfo()
      if (code == "0") {
        setLottery(data)
      } else {
        const { code, data } = await getPddInfo()
        if (code == "0") {
          setLottery(data)
        }
      }
    } catch (e) {
      console.log("🚀 ~ newData ~ newData:", e)
    }
  }, [])

  const setUserPddInfo = useCallback(async () => {
    try {
      const { code, data } = await getUserPddInfo()
      if (code == "0") {
        setUserInfo(data)
      } else {
        const { code, data } = await getUserPddInfo()
        if (code == "0") {
          setUserInfo(data)
        }
      }
    } catch (e) {

    }
  }, [])

  const setActivity_list = useCallback(async () => {
    try {
      const { code, data } = await getActivity_list()
      if (code == "0") {
        setActivityList(data)
      } else {
        const { code, data } = await getActivity_list()
        if (code == "0") {
          setActivityList(data)
        }
      }
    } catch (e) {
    }
  }, [])

  const getRewardsData = useCallback(async () => {
    try {
      const res = await rewards_count()
      if (res.code == 0) {
        setRewardsData(res.data)
      }
      const resRewards = await getRewards(1, 9999)
      if (resRewards.code == 0) {
        setRewardsList(resRewards.data.data)
      }
    } catch (e) {
      console.log("🚀 ~ getRewardsData ~ e:", e)
    }
  }, [])


  useEffect(() => {
    getRewardsData()
    setPddInfo()
    setActivity_list()
    setUserPddInfo()
    const time = setInterval(() => {
      setActivity_list()
    }, 30000)
    return () => {
      clearInterval(time)
    };
  }, [])

  const Invitation_code = async () => {
    // if (WebApp.version >= "8.0") {
    //   const toast = Toast.loading({
    //     message: "Loading",
    //     duration: 0,
    //     forbidClick: false

    //   })
    //   try {
    //     const params = {
    //       "account": Number(id),
    //       "allow_user_chats": true,
    //       "allow_bot_chats": true,
    //       "allow_group_chats": true,
    //       "allow_channel_chats": true
    //     }
    //     const { code, data } = await apiGetShareMessageId(params)
    //     if (code == "0") {
    //       // WebApp.shareMessage(data.id, (status) => {
    //       //   console.log("🚀 ~ WebApp.shareMessage ~ status:", status)
    //       // })
    //     } else {
    //       console.log(data)
    //     }
    //     toast.clear()
    //   } catch (e) {
    //     toast.clear()
    //   }
    // } else {
    if (!loading) {
      setLoading(true)
      // WebApp.openTelegramLink(`https://t.me/share/url?text=${invitation_msy}&url=https://t.me/TheStarAIBot/StarAI?startapp%3D${invitation_code}`)
      setLoading(false)
    }
    // }
  }

  const rulesArr =
    [
      {
        img: rules_bg,
        text: t("invite.participate"),
      },
      {
        img: rules_bg1,
        text: t("invite.earn10"),
      },
      {
        img: rules_bg2,
        text: t("invite.withdraw"),
      },
      {
        img: rules_bg3,
        text: t("invite.receive"),
      },
      {
        img: rules_bg4,
        text: t("invite.premium"),
      },
      {
        img: rules_bg5,
        text: t("invite.earn20"),
      },
    ]

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`
        ${'https://app.starai.pro?startapp'}=${invitation_code}
        ${(decodeURIComponent(invitation_msy || ''))}`);
      setIsCopy(true)
    } catch (err) {
    }
  };

  let lens = 0;
  useEffect(() => {
    const timer: any = setInterval(() => {
      lens += 2;
      if (lens >= 100) {
        clearInterval(timer)
        setStartDialog(true)
      }
    }, 40)
    return () => clearInterval(timer);
  }, [lens])

  function dateToTimestamp(date: string) {
    return new Date(date).getTime();
  }

  const prizeListDom = [
    {
      rotate: 90,
      text: t("spin.diamond_cards"),
      img: diamond_card,
      bgColor: '#D3E6AF',
      imgRotate: '-45',
      imgWidth: '50px',
      Width: '50%'
    },
    {
      rotate: 180,
      text: t("spin.gold_cards"),
      img: gold_cards,
      bgColor: '',
      imgWidth: '50px',
      imgRotate: '135',
      Width: '50%'
    },
    {
      rotate: 270,
      text: t("spin.star_range"),
      img: coin,
      bgColor: '#D3E6AF',
      imgRotate: '0',
      imgWidth: '38px',
      Width: '50%'
    },
    {
      rotate: 360,
      text: t("spin.usdt_range"),
      img: usdt,
      bgColor: '',
      imgWidth: '38px',
      imgRotate: '45',
      Width: '50%'
    }
  ]

  const [marqueeArray, setMarqueeArray] = useState<any>([])
  const getDataMarquee = async () => {
    const { code, data } = await getPddMarquee()
    if (code == '0') {
      setMarqueeArray(data.data)
    }
  }
  useEffect(() => {
    getDataMarquee()
  }, [])

  return (
    <div
      className="relative pt-[100px] pb-[30px] h-[100vh] overflow-hidden md:w-[375px] lg:w-[440px] xl:w-[500px] max-md:w-[100vw] bg-gradient-to-b to-[#071919] from-[#092524]">
      <div className=" h-[calc(100vh_-_100px)] overflow-auto">
        <div className=" fixed md:absolute z-40 top-[54px] left-0 w-[calc(100%_-_68px)]">
          <Marquee
          >
            <div className='py-[7px] flex w-fit gap-[10px]'>
              {marqueeArray.map((el: any, index: any) => (
                <div key={`${el.account_id}-${index}-marquee`} style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)' }} className='p-[1px] flex-shrink-0 w-fit rounded-[15px] h-[30px]'>
                  <div className='px-[6px] text-[12px] leading-[15px] font-medium text-[#ffffff] h-[28px] rounded-[15px] bg-[#000] flex justify-center items-center'>
                    {el.name || formatIdString(el.account_id, 3, 3)} {t("task.received")} &nbsp;<p className=' font-medium text-style-6 !text-[12px] !leading-[15px] '>{el.amount} {t("other.usdt")}</p>
                  </div>
                </div>))}
            </div>
          </Marquee>
        </div>

        <div className="px-4">

          <div className="bg-[#32726E]/30 rounded-tl-[20px] rounded-bl-[20px] z-10 fixed md:absolute pl-[10px] top-[66px] right-0 w-[58px] h-[30px] font-semibold text-[#fff] text-[12px] leading-5"
            onClick={() => {
              setDialog(true)
              // setLuckyDrawprize(true)
            }}>
            <span className="border-b cursor-pointer border-[#29CACE] inline text-style-1 text-[14px] leading-[30px] text-center font-semibold ">{t("invite.rules")}</span>
          </div>
        </div>
        <div className="overflow-auto h-[calc(100vh_-_100px)]">
          <div className="px-4">
            <div className="md:absolute max-md:fixed top-0 w-full h-11 p-[10px] px-4 z-[9] left-0">
            </div>
            <div className=" px-[6px] z-[1] relative mt-[6px]">
              <div className="double-border-container">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <span className="text-[14px]">{t("other.total_withdraw")}</span>
                <p>
                  <span className="text-[12px] icon-favicon font-bold">$</span>
                  <span className="text-[20px] icon-favicon font-bold mt-[2px]">{formatNumber(dataStatistics?.withdraw as number) || 0}</span>
                </p>
              </div>


              <div className=" w-[100%] h-[235px] relative rounded-[30px] pt-5 px-4">
                <p className=" !text-[46px] font-bold text-style-6 !leading-[37px] !text-center"> <span className=" !text-[30px] font-bold text-style-6 leading-[37px]">$</span>{userInfo.total || 0}</p>
                <div className="px-1 mt-[10px] w-full">
                  <div className="w-full rounded-lg h-4 bg-[#DEDEDE]">
                    <div style={{ background: 'linear-gradient( 135deg, #00E49F 0%, #54ADFF 100%)', width: `${(userInfo.total * 100 / userInfo.max) || 0}%` }} className="w-[85%] relative rounded-lg h-4">
                      <p className={`text-style-1 absolute top-[18px] ${(userInfo.total * 100 / userInfo.max) ? 'right-0' : 'right-1'}  !text-[14px] font-semibold !leading-[18px]`}>{(userInfo.total * 100 / userInfo.max) || 0}%</p>
                    </div>
                  </div>
                </div>
                <p className="text-[#fff] mt-[24px] text-center text-[14px] leading-[18px] font-semibold">
                  {t("invite.only")}
                  <span className="text-style-6  text-[14px] leading-[18px] font-semibold"> ${(userInfo.max * 1000 - userInfo.total * 1000) / 1000 || 0} </span>
                  {t("invite.left")}
                  <span className="text-style-6  text-[14px] leading-[18px] font-semibold"> ${userInfo.max || 0}</span>
                </p>
              </div>
            </div>
            <div className="w-full -mt-[195.2px] pt-[84px] rounded-[30px]">
              <div className="w-full bg-cover pb-5 bg-no-repeat relative pt-[12px] rounded-b-[30px] z-[2]">
                <div className="z-40 w-full flex items-center justify-between mb-[32px]">
                  <div className="w-[calc(100%_-_100px)] rounded-[10px] h-[40px] mt-1 bg-[#01825D]/30 text-[#fff] text-[14px] flex justify-center items-center">
                    {t("invite.withdrawable")}
                    <span className="text-style-6  ml-[10px] text-[14px] leading-[18px] font-semibold">${userInfo.withdrawn_total || 0}</span>
                  </div>
                  <ButtonComp width={92} height={36} auto={true} disabled={userInfo?.is_withdrawn ? false : true} title={t("invite.withdraw_title")} fontSize={12} callBack={() => { setIsWithdraw(true) }}></ButtonComp>
                </div>

                {/* <div className="z-40 -top-2 left-[50%] -translate-x-[50%] absolute">
                <ButtonComp width={67} disabled={userInfo?.is_withdrawn ? false : true} height={18} title={t("invite.withdraw_title")} fontSize={12} callBack={() => { setIsWithdraw(true) }} mt={6}></ButtonComp>
              {/* <img className=" absolute top-0 right-0 h-full" src={right} alt="" />
              <img className=" absolute top-0 left-0 h-full" src={left} alt="" /> */}
                <Turntable getLottery={getPddLottery} offset={45} prizeListDom={prizeListDom} setUserPddInfo={setUserPddInfo} setActivity_list={setActivity_list} number_of_draws={userInfo.number_of_draws} lottery={lottery} itemNum={4}></Turntable>
                <p onClick={() => {
                  if (localStorage.getItem('token')) {
                    setVisibleMy(true)
                  } else {
                    dispatch(changeLoginState(true))
                  }
                }} style={{ textDecoration: "underline" }} className=" text-center font-bold mt-2 text-style-1">
                  My Invites
                </p>
                <div
                  className="w-full mt-2 flex justify-between items-center text-center">
                  {/* <span onClick={() => {
                  if (localStorage.getItem('token')) {
                    setVisibleMy(true)
              
                  </div> */}
                  <p className="font-semibold text-[14px] pl-1 text-[#fff] leading-[16px]">
                    {'https://sta…/startapp'}={invitation_code}
                  </p>
                  <div onClick={(e: any) => {
                    e.preventDefault()
                    e.stopPropagation()
                    handleCopy()
                  }} className={`${isCopy ? '' : 'pt-[6px]'} items-center cursor-pointer from-[#00E49F] bg-gradient-to-r rounded-[10px] flex justify-center button_shadow to-[#54ADFF] flex-shrink-0 w-9 h-9`}>
                    <img className={` ${isCopy ? 'w-[20px]' : 'w-[28px]'}`} src={isCopy ? copy_Completed : copy} alt="" />
                  </div>
                </div>
                <div className="w-full flex mt-2 justify-center items-center">
                  <div className="w-full relative">
                    {
                      <TwitterShareButton url={' '} title={`✨ StarAI, The best AI Agent platform !
🤩 https://app.starai.pro?startapp=${invitation_code}
🚀 Play StarAI Claim 100USDT！
🏆 Participate in arena PK to earn victory ranking rewards！
🔥 Stake Cards and Agents to accelerate mining and earn ＄SAI profits！
🌐 More details: https://app.starai.pro`}>
                        <div onClick={(e: any) => {

                          if (!localStorage.getItem('token')) {
                            e.stopPropagation()
                            dispatch(changeLoginState(true))
                          }

                        }} className="new_button_shadow cursor-pointer flex gap-1  items-center text-[#fff] text-[14px] font-bold justify-center h-[36px]">
                          <img className="w-4 h-4" src={x} alt="" /> {t("spin.title")}
                        </div>
                      </TwitterShareButton>
                    }


                    <img className='absolute zoom w-9 h-9 z-10 -right-0 bottom-[-11px]' src={finger} alt="" />
                  </div>
                </div>
              </div>
              <p style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className=" text-[12px] text-center px-2 mt-5 leading-[15px] text-[#fff] font-semibold">
                {t("invite.earn10again")}
              </p>
            </div>
          </div>
          {localStorage.getItem('token') ? <div className="mt-[10px] mb-5 flex justify-center leading-[15px] text-[12px] font-semibold text-center text-[#fff]">
            <CountDown
              time={(dateToTimestamp(userInfo.activity_date)) - new Date().getTime()}
              millisecond
              format="DD:HH:mm:ss:SS"
            // onFinish={() => { onFinishHandle() }}
            >
              {({ days, hours, minutes, seconds }) => (
                <div className="flex w-full px-6 mr-[30px]">
                  <div className="flex-1 text-center text-white  mr-[15px] flex flex-col items-center justify-center">
                    <div className="time-item h-6 w-6 relative z-0 flex items-center justify-center">
                      <img src={day} alt="" className="w-full h-full absolute z-[-1]" />
                      <span className="text-[#333] text-base ">{days > 9 ? days : "0" + days}</span>
                    </div>
                    <p className="text-white  text-center text-xs mt-[2px]">{t("invite.day")}{i18n.language == 'en' && days > 9 ? "S" : ""}</p>

                  </div>
                  <div className="flex-1 text-center text-white">
                    <div className="text-center text-white flex flex-col items-center justify-center">
                      <div className="time-item h-6 w-6  bg-gradient-to-br from-[#00E49F] to-[#54ADFF] rounded-md relative z-0 flex items-center justify-center">
                        <span className="text-[#fff] text-base ">{hours > 9 ? hours : "0" + hours}</span>
                      </div>
                      <p className="text-white text-xs mt-[2px]">{t("invite.hour")}{i18n.language == 'en' && hours > 9 ? "S" : ""}</p>

                    </div>
                  </div>
                  <span className="text-white  mr-[7px] ml-[11px]">:</span>
                  <div className="flex-1 text-center text-white">
                    <div className="text-center text-white flex flex-col items-center justify-center">
                      <div className="time-item h-6 w-6  bg-gradient-to-br from-[#00E49F] to-[#54ADFF] rounded-md relative z-0 flex items-center justify-center">
                        <span className="text-[#fff] text-base ">{minutes > 9 ? minutes : "0" + minutes}</span>
                      </div>
                      <p className="text-white text-xs mt-[2px]">{t("invite.minute")}{i18n.language == 'en' && minutes > 9 ? "S" : ""}</p>

                    </div>
                  </div>
                  <span className="text-white  mx-[6px]">:</span>
                  <div className="flex-1 text-center text-white">
                    <div className="text-center text-white flex flex-col items-center justify-center">
                      <div className="time-item h-6 w-6  bg-gradient-to-br from-[#00E49F] to-[#54ADFF] rounded-md relative z-0 flex items-center justify-center">
                        <span className="text-[#fff] text-base ">{seconds > 9 ? seconds : "0" + seconds}</span>
                      </div>
                      <p className="text-white text-xs mt-[2px]">{t("invite.second")}{i18n.language == 'en' && seconds > 9 ? "S" : ""}</p>

                    </div>
                  </div>
                </div>
              )}
            </CountDown>
            {/* 7 days, 23 hours, 59 minutes. */}
          </div> :
            <div className="h-5"></div>
          }
          <div className="bg-gradient-to-b to-[#122F2F] from-[#1C514E] rounded-t-[30px] md:w-[375px] lg:w-[440px] xl:w-[500px] max-md:w-[100vw] h-[530px] pb-[120px] flex items-center px-4 flex-col pt-2">
            <div
              style={{ backgroundImage: `url(${winners_list})`, textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }}
              className=" text-[#fff] h-11 w-[182px] bg-cover font-semibold text-[16px] leading-[19px] flex items-center justify-center">
              {t("invite.winners")}
            </div>
            <div className="flex gap-[73px] mt-[10px] justify-center items-center w-full">
              <span onClick={() => { setIsAll(0) }} className={`${IsAll === 0 ? 'text-style-1 active_INVITE' : 'text-[#a6a6a6]'} relative !text-[16px] font-semibold cursor-pointer !leading-[19px]`}>{t("invite.all")}</span>
              <span onClick={() => {
                if (localStorage.getItem('token')) {
                  setIsAll(1)
                } else {
                  dispatch(changeLoginState(true))
                }
              }} className={`${IsAll === 1 ? 'text-style-1 active_INVITE' : 'text-[#a6a6a6]'} !text-[16px] relative font-semibold cursor-pointer !leading-[19px] `} >{t("invite.my")}</span>
            </div>
            <div style={{ border: '1px solid #32726E' }} className="h-[1.5px] mt-[2px] w-[calc(100%_-_16px)]"></div>
            <div className=" flex flex-col w-full h-[380px] mt-[20px] overflow-auto gap-[10px]">
              {dataList.length == 0 ?
                <div className="text-[14px] justify-center leading-[18px] text-[#fff] w-full h-full flex items-center">
                  {t("invite.norecords")}
                </div>
                : <>
                  {Array.isArray(dataList) && dataList.map((el: any, index: number) =>

                    <div key={`${index}_sss1223`} className="flex flex-shrink-0 bg-[#1C514E] rounded-[10px] justify-between h-[50px] px-[10px] w-full items-center">
                      <div className=" w-[25%] text-[14px] leading-[18px] text-[#fff] text-start flex items-center">{formatIdString(el.account_id)}</div>
                      <div className=" w-[20%] text-[14px] leading-[18px] text-[#fff] text-start flex items-center">{t("invite.referrals")} {el.invitation}</div>
                      {el.code == 'star' ?
                        <div className=" w-[30%] text-[14px] leading-[18px]  text-style-6 text-start flex items-center">
                          <img className=" h-5 w-5" src={coin} alt="" />
                          {FormattingNumber(el.amount.toString())} $STAR
                        </div> : el.code == 'usdt' ?
                          <div className=" w-[30%] text-[14px] leading-[18px]  text-style-6 text-start flex items-center">
                            <img className=" rotate-45 h-5 w-5" src={usdt} alt="" />
                            ${el.amount}
                          </div> :
                          el.code == 'card3' ?
                            <div className=" w-[30%] justify-center text-[14px] leading-[18px]  text-style-6 text-start flex items-center">
                              <img className="w-5" src={card3} alt="" />
                            </div> : <div className=" w-[30%] justify-center  text-[14px] leading-[18px]  text-style-6 text-start flex items-center">
                              <img className="w-5" src={card4} alt="" />
                            </div>
                      }
                      <div className=" w-[25%] text-[14px] leading-[18px] text-[#fff] justify-end flex items-center">{el.create_at}</div>
                    </div>
                  )}</>}
            </div>
          </div>
        </div>
        <Dialog
          visible={dialog}
          showConfirmButton={false}
          showCancelButton={false}
          closeOnClickOverlay={true}
          onClose={() => { setDialog(false) }}
          width={'100%'}
        >

          <div style={{ backgroundSize: "100% 100% !important" }} className={`w-[calc(100%_-_24px)] !bg-[length:100%_100%] overflow-visible px-[14px] relative bg-[url(@/assets/images/dialog_bg.png)] pt-[31px] mx-[12px] pb-[50px]`}>
            <CloseComp position="absolute" top={14} right={16} callBack={() => { setDialog(false) }}></CloseComp>
            <p className="font-bold text-[20px] leading-6 mb-[20px] text-center text-[#333]">{t("spin.rules")}</p>
            {rulesArr.map((el: any, index: any) =>
              <div style={{ backgroundImage: `url(${el.img})`, backgroundSize: '100% 100%' }} key={`rulesArr_${index}`} className="p-[6px] mt-[10px] flex">
                <img src={star} className="w-[14px] h-[14px] mr-[2px]" alt="" />
                <p className="text-[14px] leading-[18px] font-semibold text-[#333]" dangerouslySetInnerHTML={{ __html: HighlightPercentages(el.text) }}></p>
              </div>
            )}
          </div>
        </Dialog>

        <WithdrawDialog setUserPddInfo={setUserPddInfo} userInfo={userInfo} dialog={isWithdraw} setDialog={setIsWithdraw}></WithdrawDialog>
        <LuckyDrawprizeDialog dialog={luckyDrawprize} setDialog={setLuckyDrawprize}></LuckyDrawprizeDialog>

        <InvitingPopup
          title={t("spin.my_invites")}
          visible={visibleMy}
          rewardsData={rewardsData}
          rewardsList={rewardsList}
          setVisible={setVisibleMy}
          setLoading={setLoading}
          Invitation_code={Invitation_code}
          loading={loading} isCopy={isCopy}
          setIsCopy={setIsCopy}
          handleCopy={handleCopy}>
        </InvitingPopup>

        <Dialog
          visible={!startDialog}
          showConfirmButton={false}
          overlayStyle={{ backgroundColor: ' rgb(0 0 0 )' }}
          showCancelButton={false}
          width={'100%'}
        >
          <div className={`md:w-[375px] lg:w-[440px] xl:w-[500px] max-md:w-[100vw] flex items-center justify-center relative`}>
            <img className="fade-right w-full" src={start_bg} alt="" />
            <div className="absolute fade-left w-full">
              <img className="w-full " src={start_bg1} alt="" />
              <div className=" absolute w-full flex justify-center flex-col h-full top-0 left-0">
                <p style={{ textShadow: "0px 2px 4px rgba(130,0,0,0.5)" }} className="text-[20px] text-center  leading-6 font-bold text-[#fff]">
                  {t("spin.invitation2")}
                </p>
                <p style={{ textShadow: "0px 2px 4px rgba(130,0,0,0.5)" }} className="text-[20px] text-center mt-[2px] leading-6 font-bold text-[#fff]">
                  <span style={{ textShadow: "0px 2px 4px rgba(130,0,0,0.5)" }} className="text-style-3 text-[30px] leading-[30px] font-bold"> 100 USDT </span>
                  {t("invite.reward")}
                </p>
              </div>
            </div>
          </div>
        </Dialog>
        {
          isShowRedPacket && <RedPacket></RedPacket>
        }
      </div>
    </div>
  )
}
export default myInvites
